import { Link } from 'react-router-dom';
import { getWhatsAppUrl } from '../../../components/feature/WhatsAppButton';

export default function Footer() {
  return (
    <footer className="bg-[#F5F0E8] text-[#2A2A2A]">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand Identity */}
          <div className="sm:col-span-2 lg:col-span-1 space-y-6">
            <div>
              <h3 className="text-2xl lg:text-3xl font-serif text-[#2A2A2A] mb-2">
                TADASHI CONSULTING
              </h3>
              <div className="w-20 h-0.5 bg-[#D4AF37]"></div>
            </div>
            <p className="text-base text-gray-600 leading-relaxed">
              Luxury renovations built to last
            </p>
            <p className="text-sm text-gray-500 leading-relaxed">
              Full-service renovation and construction partner specializing in
              luxury residential and commercial transformations in Johannesburg.
            </p>
            <div className="flex items-center gap-4 pt-4">
              <a
                href="https://www.instagram.com/tadashi_interior_design?utm_source=qr&igsh=MWNzNGx6ajMzNjluMA=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all flex items-center justify-center cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href={getWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white transition-all flex items-center justify-center cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <div>
              <h4 className="text-base font-semibold text-[#2A2A2A] uppercase mb-2">
                <a href="/#services">Services</a>
              </h4>
              <div className="w-10 h-0.5 bg-[#D4AF37]"></div>
            </div>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/residential-renovations"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Residential Renovations
                </Link>
              </li>
              <li>
                <Link
                  to="/commercial-construction"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Commercial Construction
                </Link>
              </li>
              <li>
                <a
                  href="/#services"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Structural Upgrades
                </a>
              </li>
              <li>
                <a
                  href="/#services"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  High-End Fit-Outs
                </a>
              </li>
              <li>
                <a
                  href="/#services"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Luxury Finishes
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-6">
            <div>
              <h4 className="text-base font-semibold text-[#2A2A2A] uppercase mb-2">
                <a href="/#about">Company</a>
              </h4>
              <div className="w-10 h-0.5 bg-[#D4AF37]"></div>
            </div>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  About Us
                </Link>
              </li>
              <li>
                <a
                  href="/#process"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Our Process
                </a>
              </li>
              <li>
                <a
                  href="/#gallery"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Project Gallery
                </a>
              </li>
              <li>
                <a
                  href="/#testimonials"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <a
                  href="/#contact"
                  className="text-sm text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <div>
              <h4 className="text-base font-semibold text-[#2A2A2A] uppercase mb-2">
                <a href="/#contact">Get In Touch</a>
              </h4>
              <div className="w-10 h-0.5 bg-[#D4AF37]"></div>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-lg text-[#D4AF37] mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                    Address
                  </p>
                  <p className="text-sm text-[#2A2A2A]">
                    1 Wakis Road, Strydom Park
                    <br />
                    Block E 1, Randburg
                    <br />
                    Johannesburg, South Africa
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-lg text-[#D4AF37] mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                    Phone
                  </p>
                  <a
                    href="tel:0118752075"
                    className="text-sm text-[#2A2A2A] hover:text-[#D4AF37] transition-colors"
                  >
                    011 875 2075
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-lg text-[#25D366] mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                    WhatsApp
                  </p>
                  <a
                    href={getWhatsAppUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#2A2A2A] hover:text-[#25D366] transition-colors"
                  >
                    +27 65 215 1468
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-lg text-[#D4AF37] mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                    Email
                  </p>
                  <a
                    href="mailto:info@tadashiconsulting.co.za"
                    className="text-sm text-[#2A2A2A] hover:text-[#D4AF37] transition-colors break-all"
                  >
                    info@tadashiconsulting.co.za
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#D4AF37]/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500 text-center sm:text-left">
            &copy; 2025 Tadashi Consulting. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <a
              href="#"
              className="text-sm text-gray-500 hover:text-[#D4AF37] transition-colors cursor-pointer"
              rel="nofollow"
            >
              Privacy Policy
            </a>
            <span className="w-1 h-1 bg-[#D4AF37] rounded-full hidden sm:block"></span>
            <a
              href="#"
              className="text-sm text-gray-500 hover:text-[#D4AF37] transition-colors cursor-pointer"
              rel="nofollow"
            >
              Terms of Service
            </a>
            <span className="w-1 h-1 bg-[#D4AF37] rounded-full hidden sm:block"></span>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
